import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { BackButton, BackIconCircle } from "./styles";

interface BackComponentProps {
    text?: string;
    to?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
}

const BackComponent = ({ text, to, onClick, style }: BackComponentProps) => {
	const navigate = useNavigate();

	const handleClick = () => {
		if (onClick) {
			onClick();
			return;
		}
		if (to) {
			navigate(to);
			return;
		}
		navigate(-1);
	};

	return (
		<BackButton type="button" onClick={handleClick} style={style}>
			<BackIconCircle className="back-icon">
				<ArrowLeftOutlined />
			</BackIconCircle>
			<span>{text}</span>
		</BackButton>
	);
};

export default BackComponent;
